import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import React, { useEffect, useCallback, useRef } from 'react';
import GuardDashboard from '../components/guard';
import * as guardActions from '../redux/actions/guardActions';

const GuardDevicesPageContainer = ({
  guard,
  actions,
}) => {
  const searchTimeoutRef = useRef(null);

  useEffect(() => {
    actions.fetchGuardDevices();
    actions.fetchVersionDistribution();
    actions.fetchGuardReleases();
  }, []);

  const handleSelectDevice = useCallback(
    (deviceId) => {
      if (!deviceId) return;
      actions.fetchGuardDevice(deviceId);
    },
    [actions]
  );

  const handleClearDevice = useCallback(() => {
    actions.clearSelectedDevice();
  }, [actions]);

  const handleRefresh = useCallback(() => {
    actions.fetchGuardDevices();
    actions.fetchVersionDistribution();
    actions.fetchGuardReleases();
  }, [actions]);

  const handleRefreshReleases = useCallback(() => {
    actions.fetchGuardReleases();
  }, [actions]);

  const handleSaveReleasePolicy = useCallback(
    (policy) => {
      actions.saveGuardReleasePolicy(policy);
    },
    [actions]
  );

  const handleRevoke = useCallback(
    (deviceId) => {
      actions.revokeGuardDevice(deviceId);
      actions.clearSelectedDevice();
    },
    [actions]
  );

  const handleSearch = useCallback(
    (value) => {
      if (searchTimeoutRef.current) clearTimeout(searchTimeoutRef.current);
      searchTimeoutRef.current = setTimeout(() => {
        actions.fetchGuardDevices(value || undefined);
      }, 300);
    },
    [actions]
  );

  return (
    <GuardDashboard
      loading={guard.loading}
      error={guard.error}
      devices={guard.devices}
      selectedDevice={guard.selectedDevice}
      selectedDeviceEvents={guard.selectedDeviceEvents}
      versionDistribution={guard.versionDistribution}
      releases={guard.releases}
      releasePolicy={guard.releasePolicy}
      releaseEnvOverrides={guard.releaseEnvOverrides}
      onSelectDevice={handleSelectDevice}
      onClearDevice={handleClearDevice}
      onRefresh={handleRefresh}
      onRefreshReleases={handleRefreshReleases}
      onSaveReleasePolicy={handleSaveReleasePolicy}
      onRevoke={handleRevoke}
      onSearch={handleSearch}
    />
  );
};

const mapStateToProps = (state) => ({
  guard: state.guard,
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(guardActions, dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(GuardDevicesPageContainer);
